import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { User } from '@sss/sdk';
import { sdk } from '../../lib/sdk';

interface Props {
  me: User;
  /** Called after the account is marked for deletion — caller signs out. */
  onAccountDeleted: () => void;
}

export default function DangerZoneTab({ me, onAccountDeleted }: Props) {
  const { t } = useTranslation();
  const [confirmEmail, setConfirmEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const canDelete = confirmEmail.trim().toLowerCase() === me.email.toLowerCase();

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!canDelete) return;
    setBusy(true);
    setError(null);
    try {
      await sdk.users.deleteSelf();
      onAccountDeleted();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed');
      setBusy(false);
    }
  }

  return (
    <section style={panel}>
      <h3 style={{ marginTop: 0 }}>{t('settings.dangerZone.title')}</h3>

      <h4>{t('settings.dangerZone.deleteAccount')}</h4>
      <p style={{ color: '#666' }}>{t('settings.dangerZone.deleteAccountHint')}</p>

      <form onSubmit={onSubmit} style={form_}>
        <label style={label}>
          {t('settings.dangerZone.confirmDelete')}
          <input
            type="email"
            placeholder={me.email}
            value={confirmEmail}
            onChange={(e) => setConfirmEmail(e.target.value)}
            style={input}
          />
        </label>
        <div>
          <button type="submit" disabled={!canDelete || busy} style={btnDanger}>
            {busy ? t('common.loading') : t('settings.dangerZone.confirmDeleteButton')}
          </button>
        </div>
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </form>
    </section>
  );
}

const panel: React.CSSProperties = { border: '1px solid #d00', borderRadius: 4, padding: '1rem' };
const form_: React.CSSProperties = { display: 'flex', flexDirection: 'column', gap: '1rem' };
const label: React.CSSProperties = { display: 'flex', flexDirection: 'column', gap: '0.25rem' };
const input: React.CSSProperties = { padding: '0.5rem', border: '1px solid #ccc', borderRadius: 4, font: 'inherit' };
const btnDanger: React.CSSProperties = { padding: '0.5rem 1rem', background: '#c00', color: '#fff', border: 0, borderRadius: 4, cursor: 'pointer' };
